import { GradientContainer } from "@/components/gradient-container/GradientContainer.tsx";
import { BlogPost } from "@/pages/blog/components/BlogPost.tsx";
import { BlogEditSteps, useBlogEditContext } from "@/types/blog.types.ts";
import { Button, FullScreenPage, Stack } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function BlogPostEditPreview() {
  const { t } = useTranslation();
  const { setStep, post } = useBlogEditContext();
  const navigate = useNavigate();

  return (
    <FullScreenPage
      title={t("blog:preview_post")}
      backSlot={
        <Button
          variant={"secondary"}
          size={"lg"}
          onClick={() => {
            navigate(-1);
          }}
        >
          {t("common:exit")}
        </Button>
      }
      backgroundSlot={
        post?.hero_image_file?.color_palette && (
          <GradientContainer
            colorPalette={post?.hero_image_file?.color_palette}
            addLightOverlayTop={true}
          />
        )
      }
      actionsSlot={
        <Stack direction={"horizontal"} gap={"sm"}>
          <Button
            onClick={() => {
              setStep(BlogEditSteps.form);
            }}
            variant="secondary"
            size={"lg"}
          >
            {t("common:back")}
          </Button>
          <Button
            size={"lg"}
            onClick={() => {
              setStep(BlogEditSteps.settings);
            }}
          >
            {t("common:continue")}
          </Button>
        </Stack>
      }
    >
      <Stack className={"container-sm ml-auto mr-auto relative pb-(--gap-3xl)"} gap={"sm"}>
        {post && <BlogPost post={post} mode={"preview"} />}
        <Button
          size={"lg"}
          onClick={() => {
            setStep(BlogEditSteps.settings);
          }}
        >
          {t("common:continue")}
        </Button>
      </Stack>
    </FullScreenPage>
  );
}
